const Config = {
  apiUrl: 'https://admin.jcigrand.mn/wp-json',
};

export default Config;
